import { useCallback } from "react";

import { usePresentation } from "../presentation";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { useAppSelector } from "store/index";
import {
  selectCurrentSectionId,
  selectIsPresentationActive,
  selectPresentedPageId,
} from "store/selectors";
import { selectCurrentBreakoutGroupId, selectIsInBreakout } from "store/selectors/breakouts";
import { useNavigate } from "utils/routing";
import { pageUrl, withQueryParams } from "utils/urls";

export const useFollow = () => {
  const navigate = useNavigate();
  const { isFollowing, isPresenting } = usePresentation();
  const isPresentationActive = useAppSelector(selectIsPresentationActive);
  const presentedPageId = useAppSelector(selectPresentedPageId);
  const sectionId = useAppSelector(selectCurrentSectionId);
  const isInBreakout = useAppSelector(selectIsInBreakout);
  const currentBreakoutGroupId = useAppSelector(selectCurrentBreakoutGroupId);

  const maybeStartFollowing = useCallback(() => {
    if (
      isPresentationActive &&
      !isPresenting &&
      !isFollowing &&
      (!isInBreakout || !currentBreakoutGroupId) &&
      sectionId &&
      presentedPageId
    ) {
      const presentedPageURL = withQueryParams(pageUrl(sectionId, presentedPageId), {
        [FOLLOWING_QUERY_PARAM]: "active",
      });
      navigate(presentedPageURL);
    }
  }, [
    isPresentationActive,
    isPresenting,
    isFollowing,
    sectionId,
    presentedPageId,
    navigate,
    isInBreakout,
    currentBreakoutGroupId,
  ]);

  return { maybeStartFollowing };
};
